import { importDelay } from "@/debugConfig.ts";
import sleep from "@warrenio/utils/promise/sleep";

export async function delayed<T>(value: Promise<T>, delay: number = importDelay) {
    await sleep(delay);
    return await value;
}
